import { render, staticRenderFns } from "./tbfx1.vue?vue&type=template&id=257ad385"
import script from "./tbfx1.vue?vue&type=script&lang=js"
export * from "./tbfx1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports